// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CompaniesSearchRequestDto } from '../models';
// @ts-ignore
import type { CompaniesSearchResponseDto } from '../models';
// @ts-ignore
import type { CompaniesSortValuesDto } from '../models';
// @ts-ignore
import type { DictionaryLanguageDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
/**
 * CompaniesSearchRestApi - axios parameter creator
 */
export const CompaniesSearchRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Search companies
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {CompaniesSortValuesDto} companiesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {CompaniesSearchRequestDto} [companiesSearchRequestDto] Companies search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanies: async (page: number, pageSize: number, sortDirection: SortDirectionDto, companiesSort: CompaniesSortValuesDto, language: DictionaryLanguageDto, companiesSearchRequestDto?: CompaniesSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchCompanies', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchCompanies', 'pageSize', pageSize)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('searchCompanies', 'sortDirection', sortDirection)
            // verify required parameter 'companiesSort' is not null or undefined
            assertParamExists('searchCompanies', 'companiesSort', companiesSort)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('searchCompanies', 'language', language)
            const localVarPath = `/api/v1/companies/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (companiesSort !== undefined) {
                localVarQueryParameter['companiesSort'] = companiesSort;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companiesSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesSearchRestApi - functional programming interface
 */
export const CompaniesSearchRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompaniesSearchRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Search companies
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {CompaniesSortValuesDto} companiesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {CompaniesSearchRequestDto} [companiesSearchRequestDto] Companies search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCompanies(page: number, pageSize: number, sortDirection: SortDirectionDto, companiesSort: CompaniesSortValuesDto, language: DictionaryLanguageDto, companiesSearchRequestDto?: CompaniesSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCompanies(page, pageSize, sortDirection, companiesSort, language, companiesSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesSearchRestApi.searchCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompaniesSearchRestApi - factory interface
 */
export const CompaniesSearchRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompaniesSearchRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Search companies
         * @param {number} page 
         * @param {number} pageSize 
         * @param {SortDirectionDto} sortDirection 
         * @param {CompaniesSortValuesDto} companiesSort 
         * @param {DictionaryLanguageDto} language 
         * @param {CompaniesSearchRequestDto} [companiesSearchRequestDto] Companies search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCompanies(page: number, pageSize: number, sortDirection: SortDirectionDto, companiesSort: CompaniesSortValuesDto, language: DictionaryLanguageDto, companiesSearchRequestDto?: CompaniesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesSearchResponseDto> {
            return localVarFp.searchCompanies(page, pageSize, sortDirection, companiesSort, language, companiesSearchRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompaniesSearchRestApi - interface
 */
export interface CompaniesSearchRestApiInterface {
    /**
     * 
     * @summary Search companies
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {CompaniesSortValuesDto} companiesSort 
     * @param {DictionaryLanguageDto} language 
     * @param {CompaniesSearchRequestDto} [companiesSearchRequestDto] Companies search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCompanies(page: number, pageSize: number, sortDirection: SortDirectionDto, companiesSort: CompaniesSortValuesDto, language: DictionaryLanguageDto, companiesSearchRequestDto?: CompaniesSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesSearchResponseDto>;

}

/**
 * CompaniesSearchRestApi - object-oriented interface
 */
export class CompaniesSearchRestApi extends BaseAPI implements CompaniesSearchRestApiInterface {
    /**
     * 
     * @summary Search companies
     * @param {number} page 
     * @param {number} pageSize 
     * @param {SortDirectionDto} sortDirection 
     * @param {CompaniesSortValuesDto} companiesSort 
     * @param {DictionaryLanguageDto} language 
     * @param {CompaniesSearchRequestDto} [companiesSearchRequestDto] Companies search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCompanies(page: number, pageSize: number, sortDirection: SortDirectionDto, companiesSort: CompaniesSortValuesDto, language: DictionaryLanguageDto, companiesSearchRequestDto?: CompaniesSearchRequestDto, options?: RawAxiosRequestConfig) {
        return CompaniesSearchRestApiFp(this.configuration).searchCompanies(page, pageSize, sortDirection, companiesSort, language, companiesSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

